import { Injectable } from '@angular/core';

/**
 * Generates a pseudo-GUID. Not guaranteed to be unique!
 */
@Injectable({
  providedIn: 'root',
})
export class GuidService {
  /**
   * Already generated GUIDs
   */
  public ids: string[] = [];

  /**
   * Generates a pseudo-GUID. Not guaranteed to be unique!
   */
  public generate(): string {
    let isUnique = false;
    let tempId = '';

    while (!isUnique) {
      tempId = this.generator();
      if (!this.idExists(tempId)) {
        isUnique = true;
        this.ids.push(tempId);
      }
    }

    return tempId;
  }

  /**
   * Generates a pseudo-GUID. Not guaranteed to be unique!
   */
  private generator(): string {
    return `${this.S4()}${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}${this.S4()}${this.S4()}`;
  }

  /**
   * Checks if the ID exists already
   * @param id
   */
  private idExists(id: string): boolean {
    return this.ids.includes(id);
  }

  /**
   * Generates a group of 4 entries from 0x0 to 0xF
   */
  private S4(): string {
    // using this pseudorandom number generator is safe here.
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
}
